import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=7bc22b8a&scoped=true"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=7bc22b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc22b8a",
  null
  
)

export default component.exports